import React from 'react';

import styles from './following.module.css'


const ListItem = ()=>{
    return(
        <div className={styles.ListItem}>
            <img src="https://vsam.me/api/images/010421024708219727ab384186e84317b25550adfdcb25231.png" />
            <div className={styles.nameList}>
                <div className={styles.uname}>
                    arhamchoudhary
                </div>
                <span>
                    Arham Choudhary
                </span>
            </div>
            <button className="unfollowbtn">Unfollow</button>

        </div>
    )
}




const FollowingList =()=>{
    return(
        <div className={styles.con}>
            <div className={styles.Header} >
                <h2>Following</h2>
                <input placeholder="search here" />
            </div>
           <ListItem/>
           <ListItem/>
           <ListItem/>
           <ListItem/>
           <ListItem/>
           <ListItem/>
           <ListItem/>
           <ListItem/>
           <ListItem/>
           <ListItem/>
           <ListItem/> <ListItem/> <ListItem/> <ListItem/>
        </div>
    )
}


export default FollowingList 